import { Text, View } from '@react-pdf/renderer';
import {
  AbsorptionAndLiquidityPDFData,
  InstallmentSimulationPDFData,
  ValuationVGVPDFData,
} from '../usePDFData';
import nls from '../../../nls/pt-BR.json';
import { tableStyles as styles } from './styles';

type DataTypes =
  | ValuationVGVPDFData
  | InstallmentSimulationPDFData
  | AbsorptionAndLiquidityPDFData;

interface Props {
  data?: DataTypes;
  title: string;
}

const dictionary = nls.pdfReport.table.tableKeys;

type PickByValue<T, V> = Pick<
  T,
  { [K in keyof T]: T[K] extends V ? K : never }[keyof T]
>;

type Entries<T> = {
  [K in keyof T]: [keyof PickByValue<T, T[K]>, T[K]];
}[keyof T][];

export const Table: React.FC<Props> = ({ data, title }) => {
  const entries = data
    ? (Object.entries(data) as Entries<DataTypes>)
    : undefined;
  return (
    <View>
      <Text style={styles.sectionTitle}>{title}</Text>
      <View>
        {entries &&
          entries.map((elem, index) => (
            <View
              key={index}
              style={[
                styles.row,
                index % 2 !== 0 ? styles.oddRow : styles.evenRow,
              ]}
            >
              <Text style={{ opacity: 1 }}>
                {dictionary[elem[0] as unknown as keyof typeof dictionary]}
              </Text>
              <Text style={{ opacity: 1 }}>{elem[1]}</Text>
            </View>
          ))}
      </View>
    </View>
  );
};

interface VGVProps {
  data?: ValuationVGVPDFData;
  title: string;
}

export const VGVTable: React.FC<VGVProps> = ({ data, title }) => {
  if (!data) return <></>;
  const { isEdited, pricePerUnit, ...entries } = data;
  const asArray = Object.entries(entries) as Entries<DataTypes>;
  return (
    <View>
      <Text style={styles.sectionTitle}>{title}</Text>
      <View>
        <View style={[styles.row, styles.oddRow]}>
          <Text style={{ opacity: 1 }}>
            {dictionary.pricePerUnit}
            {isEdited && '(editado)'}
          </Text>
          <Text style={{ opacity: 1 }}>{pricePerUnit}</Text>
        </View>
        {asArray &&
          asArray.map((elem, index) => (
            <View
              key={index}
              style={[
                styles.row,
                index % 2 !== 0 ? styles.oddRow : styles.evenRow,
              ]}
            >
              <Text style={{ opacity: 1 }}>
                {dictionary[elem[0] as unknown as keyof typeof dictionary]}
              </Text>
              <Text style={{ opacity: 1 }}>{elem[1]}</Text>
            </View>
          ))}
      </View>
    </View>
  );
};
